import React from "react";
import { placesSlice } from "@common/redux/slices/entities.slice";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice"
import { Layout } from "@kursk/components/Layout/Layout";
import { Socials } from "../Home/Socials/Socials";
import { MuseumsGrid } from "./MuseumsGrid/MuseumsGrid";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import { SubscribeFooterForm } from "@kursk/components/ui/SubscribeFooterForm/SubscribeFooterForm";
import styles from './Museums.module.scss';
import { CatalogueTitle } from "@kursk/components/ui/CatalogueTitle/CatalogueTitle";


export const Museums = () => {
  const { total } = useSelectSlice(placesSlice);

  return (
    <Layout showSubscribePopup={false}>
      <SeoMetaTitles page="museums"/>
      <section className={styles.section_content}>
        <div className={styles.header}>
          <CatalogueTitle
            title={'Виртуальные музеи'}
            dashTitle={'Найдено музеев'}
            total={total}
          />
        </div>
        <MuseumsGrid/>
        <div className={styles.subscribeSection}>
          <SubscribeFooterForm/>
        </div>
        <div className={styles.section}>
          <Socials/>
        </div>
      </section>
    </Layout>
  );
}
